import M from 'messages';

export default [
  {
    value: 1,
    title: M.get('filterFields.yes'),
  },
  {
    value: 0,
    title: M.get('filterFields.no'),
  },
];
